import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartRoutingModule } from './start-routing.module';
import { IndexComponent } from './index/index.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [IndexComponent],
  imports: [
    CommonModule,
    StartRoutingModule,
    RouterModule,
    SharedModule,

  ]
})
export class StartModule { }
